module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$acl('edit-clients')) ? _c('div', {
    staticClass: "component-client-smart-edit"
  }, [_c('smart-edit', {
    attrs: {
      "options": _vm.options,
      "value": _vm.item
    },
    on: {
      "input": _vm.updateFields
    }
  }), _c('button', {
    staticClass: "button expanded",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Save and Submit")])], 1) : _c('h3', [_vm._v("Your account doesn't have permission to edit clients.")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-761af23d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/smartedits/ClientEdit.vue
// module id = 2604
// module chunks = 1